import { isEmpty } from 'lodash';
import { getElementId, getTitle } from '../../../../../../common/elements/utils/elementPropertyUtils';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { Tag } from '../../../../../../common/tags/tagTypes';

export const isTagMultiContext = (tag: Tag): boolean => tag.rootBoardIds?.length > 1;

// Find the id of the board in the current share context that the tag is associated with
// It will return the lowest level board id in the shareRootPath that matches one of the tag's rootBoardIds
export const getCurrentContextRootId = (tag: Tag, shareRootPath: ImMNElement[]): string | undefined => {
    // Search from the bottom of the share path to find the closest matching rootBoardId
    const boardIds = shareRootPath.map((element) => getElementId(element)).reverse();
    return tag.rootBoardIds.find((id) => boardIds.includes(id));
};

export const getHighestTagBoardId = (tag: Tag, userRootPath: ImMNElement[]): string | undefined => {
    for (const board of userRootPath) {
        const id = getElementId(board);
        if (tag.rootBoardIds.includes(id)) {
            return id;
        }
    }
    return undefined;
};

export const createIsTagInPath = (path: ImMNElement[]) => {
    const pathIds = new Set(path.map(getElementId));

    return (tag: Tag) => tag.rootBoardIds.some((id) => pathIds.has(id));
};

type TagsByBoards = {
    title: string;
    tags: Tag[];
}[];

export const generateTagsByBoardsArray = (
    allTags: Tag[],
    userRootPath: ImMNElement[],
    searchString: string,
): TagsByBoards => {
    const searchValue = searchString.toLowerCase();
    const isIncludedInSearch = (tag: Tag) => isEmpty(searchValue) || tag.name.toLowerCase().includes(searchValue);
    const isTagInPath = createIsTagInPath(userRootPath);

    const filteredTags = allTags.filter((tag) => isIncludedInSearch(tag) && isTagInPath(tag));

    const tagsByBoards: TagsByBoards = userRootPath.reduce((acc: TagsByBoards, board: ImMNElement) => {
        const boardId = getElementId(board);
        const tags: Tag[] = [];

        for (let i = filteredTags.length - 1; i >= 0; i--) {
            const tag = filteredTags[i];

            // Add the tag to the current board, and remove it from the list so that it can't be added to any other boards
            if (tag.rootBoardIds.includes(boardId)) {
                tags.push(tag);
                filteredTags.splice(i, 1);
            }
        }

        if (!tags.length) return acc;

        const title = getTitle(board);
        acc.push({ title, tags });

        return acc;
    }, []);

    return tagsByBoards;
};
